if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.sticky-atc__button');
        this.buttonText = this.querySelector('.sticky-atc__button-text');
        this.priceWrapper = this.querySelector('.sticky-atc__price-wrapper');
        this.sectionId = this.dataset.sectionId;
        this.targetFormId = this.dataset.targetForm;
        this.buyButtonsId = this.dataset.buyButtonsId;
      }

      connectedCallback() {
        this.setupIntersectionObserver();
        this.setupClickHandler();
        this.setupVariantChangeListener();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantChangeUnsubscribe?.();
      }

      setupIntersectionObserver() {
        const buyButtons = document.getElementById(this.buyButtonsId);
        if (!buyButtons) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.hide();
              } else {
                const rect = entry.boundingClientRect;
                if (rect.top < 0 || rect.bottom < 0) {
                  this.show();
                }
              }
            });
          },
          { threshold: 0 }
        );

        this.observer.observe(buyButtons);
      }

      setupClickHandler() {
        this.button?.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick() {
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

        const form = document.getElementById(this.targetFormId);
        if (!form) return;

        this.button.classList.add('loading');
        form.requestSubmit();

        setTimeout(() => {
          this.button.classList.remove('loading');
        }, 2000);
      }

      setupVariantChangeListener() {
        if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.variantChangeUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const { data } = event;
          if (data.sectionId !== this.sectionId) return;

          this.updateFromVariant(data.variant);
        });
      }

      updateFromVariant(variant) {
        if (!variant) {
          this.updateButtonState(false, window.variantStrings.unavailable);
          return;
        }

        if (!variant.available) {
          this.updateButtonState(false, window.variantStrings.soldOut);
          return;
        }

        this.updateButtonState(true, window.variantStrings.addToCart.toUpperCase());
        this.updatePrice(variant.price, variant.compare_at_price);
      }

      updateButtonState(available, text) {
        if (!this.button || !this.buttonText) return;

        if (available) {
          this.button.removeAttribute('disabled');
          this.buttonText.innerHTML = `
            ${text}
            <span class="svg-wrapper" style="display: inline-block; width: 13px; height: 13px; margin-left: 8px; vertical-align: middle;">
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.75 7.25H0V5.75H5.75V0H7.25V5.75H13V7.25H7.25V13H5.75V7.25Z" fill="currentColor"/>
              </svg>
            </span>
          `;
        } else {
          this.button.setAttribute('disabled', 'disabled');
          this.buttonText.textContent = text;
        }
      }

      updatePrice(price, compareAtPrice) {
        if (!this.priceWrapper) return;

        const formattedPrice = this.formatMoney(price);

        if (compareAtPrice && compareAtPrice > price) {
          const formattedCompare = this.formatMoney(compareAtPrice);
          const savePercent = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
          this.priceWrapper.innerHTML = `
            <span class="sticky-atc__price sticky-atc__price--sale">${formattedPrice}</span>
            <span class="sticky-atc__compare-price">${formattedCompare}</span>
            <span class="sticky-atc__save-badge">Save ${savePercent}%</span>
          `;
        } else {
          this.priceWrapper.innerHTML = `
            <span class="sticky-atc__price">${formattedPrice}</span>
          `;
        }
      }

      formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return `$${amount}`;
      }

      show() {
        this.removeAttribute('hidden');
        requestAnimationFrame(() => {
          this.classList.add('sticky-atc--visible');
        });
      }

      hide() {
        this.classList.remove('sticky-atc--visible');
        this.addEventListener(
          'transitionend',
          () => {
            if (!this.classList.contains('sticky-atc--visible')) {
              this.setAttribute('hidden', '');
            }
          },
          { once: true }
        );
      }
    }
  );
}
